import pump from 'pump'
import { Duplex } from 'stream'
import { Substream } from '@metamask/object-multiplex/dist/Substream'

import { IPromiseManager, PromiseManager } from '@/shared/promiseManager'
import { EthJsonRpcMethod } from '@/shared/models/jsonRPCMethod'
import { createJRpcMessage } from '@/shared/createJRpcMessage'
import { RequestArguments } from '@/inpage/EthereumProvider.d'

export interface IEthProvider {
  request<Response>(arguments_: RequestArguments): Promise<Response | Error>
}

export class EthProvider implements IEthProvider {
  private stream: Duplex
  private promiseManager: IPromiseManager

  constructor(connectionStream: Substream) {
    this.promiseManager = new PromiseManager()

    this.stream = new Duplex({
      objectMode: true,
      read: () => false,
      write: this.processMessage.bind(this),
    })

    pump(this.stream, connectionStream, this.stream)
  }

  public request<Response>(args: RequestArguments): Promise<Response | Error> {
    const { method, params } = args
    const { id, message } = createJRpcMessage(
      method as EthJsonRpcMethod,
      params
    )
    const promise = this.promiseManager.register<Response>(id)
    this.stream.push(message)
    return promise
  }

  private processMessage(
    data: any,
    _encoding: unknown,
    cb: (error?: Error | null) => void
  ) {
    try {
      if (data instanceof Error || !('id' in data)) {
        return
      }

      if (data.error) {
        this.promiseManager.reject(data.id, data.error)
        return
      }

      this.promiseManager.resolve(data.id, data.result)
    } finally {
      cb()
    }
  }
}
